import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=6d8f8e7b"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8f8e7b')) {
      api.createRecord('6d8f8e7b', component.options)
    } else {
      api.reload('6d8f8e7b', component.options)
    }
    module.hot.accept("./quill.vue?vue&type=template&id=6d8f8e7b", function () {
      api.rerender('6d8f8e7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/quill.vue"
export default component.exports